<lib-social-wall-widget
  [channelId]="data.social_wall?.items?.[0]?.id ?? null"
  [defaultChannelId]="defaultChannelId()"
  [animation]="data.animation"
  [animationDelay]="data.animationDelay"
  (seeAllPosts)="navigateToSocialWall()">
</lib-social-wall-widget>
